import React from 'react';
import { Paragraph } from 'common-components/typography';
import _ from 'lodash';
import { ErrorSVG } from 'assets/UndrawSVG';

export const AssignWorkerStep5 = () => {
  return (
    <div style={{ minHeight: 317 }} className='flex-column justify-center text-align-center'>
      <div className='pv-medium flex-column justify-center'>
        <img src={ErrorSVG} alt={'Error'} style={{ height: '200px' }} />
      </div>

      <div className='mb-medium flex-column justify-center '>
        <Paragraph>Oops something went wrong, please try again.</Paragraph>
      </div>
    </div>
  );
};
